import { Typography } from "@mui/material";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { RowModeIds } from "../../../builderPackage/components/editableDataGrid/editableDataGrid.entity";
import { MuiStack } from "../../../components";
import { systemColor } from "../../../theme/systemColor";
export var PartInvoiceDetails = function (props) {
    var _value$name;
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'Parts' : _a;
    var currValue = (_value$name = value[name]) === null || _value$name === void 0 ? void 0 : _value$name.filter(function (item) { return item.PostingTypeName === (value === null || value === void 0 ? void 0 : value.SelectedButton); });
    console.log("currValue-------->", currValue);
    var getTaxComponentAmount = function (data, taxName) {
        var _data$SavedPriceWithT;
        if (data !== null && data !== void 0 && (_data$SavedPriceWithT = data.SavedPriceWithTax) !== null && _data$SavedPriceWithT !== void 0 && _data$SavedPriceWithT.Taxes && Array.isArray(data.SavedPriceWithTax.Taxes)) {
            var tax = data === null || data === void 0 ? void 0 : data.SavedPriceWithTax.Taxes.find(function (tax) { return (tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === taxName; });
            return tax ? tax === null || tax === void 0 ? void 0 : tax.TaxComponentAmount : 0;
        }
        return 0;
    };
    var getTaxComponentPercentage = function (data, taxName) {
        var _data$SavedPriceWithT2, _data$SavedPriceWithT3;
        if (data !== null && data !== void 0 && (_data$SavedPriceWithT2 = data.SavedPriceWithTax) !== null && _data$SavedPriceWithT2 !== void 0 && _data$SavedPriceWithT2.Taxes && Array.isArray(data === null || data === void 0 || (_data$SavedPriceWithT3 = data.SavedPriceWithTax) === null || _data$SavedPriceWithT3 === void 0 ? void 0 : _data$SavedPriceWithT3.Taxes)) {
            var tax = data === null || data === void 0 ? void 0 : data.SavedPriceWithTax.Taxes.find(function (tax) { return (tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === taxName; });
            return tax ? tax === null || tax === void 0 ? void 0 : tax.TaxComponentPercentage : 0;
        }
        return 0;
    };
    var partsColumns = [{
            field: 'ChildName',
            headerName: 'Part name & code',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            renderCell: function (params) {
                if ((params === null || params === void 0 ? void 0 : params.id) === RowModeIds.Aggregation) {
                    return 'Total';
                }
                else {
                    var _params$row$ChildName, _params$row, _params$row2, _params$row3;
                    return /*#__PURE__*/ React.createElement(MuiStack, {
                        direction: 'column'
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        variant: "caption"
                    }, (_params$row$ChildName = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ChildName) !== null && _params$row$ChildName !== void 0 ? _params$row$ChildName : ""), /*#__PURE__*/ React.createElement(Typography, {
                        color: systemColor.lightGrey,
                        variant: "caption"
                    }, params !== null && params !== void 0 && (_params$row2 = params.row) !== null && _params$row2 !== void 0 && _params$row2.ChildCode ? "#".concat(params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.ChildCode) : ""));
                }
            }
        }, {
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            field: 'ServiceTypeName',
            headerName: 'Service type',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true
        }, {
            type: 'number',
            field: 'Quantity',
            headerName: 'Qty    ',
            width: 200,
            headerAlign: 'center',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                var _row$SavedPriceWithTa, _row$SavedPriceWithTa2;
                return (_row$SavedPriceWithTa = row === null || row === void 0 || (_row$SavedPriceWithTa2 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa2 === void 0 ? void 0 : _row$SavedPriceWithTa2.Quantity) !== null && _row$SavedPriceWithTa !== void 0 ? _row$SavedPriceWithTa : 0;
            }
        }, {
            field: 'Rate',
            headerName: 'Rate (₹)',
            align: 'center',
            width: 200,
            headerAlign: 'center',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                var _row$SavedPriceWithTa3, _row$SavedPriceWithTa4;
                return (_row$SavedPriceWithTa3 = row === null || row === void 0 || (_row$SavedPriceWithTa4 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa4 === void 0 ? void 0 : _row$SavedPriceWithTa4.Rate) !== null && _row$SavedPriceWithTa3 !== void 0 ? _row$SavedPriceWithTa3 : 0;
            }
        }, {
            field: 'DiscountPercentage',
            headerName: 'Discount rate (%)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            editable: false
        }, {
            field: 'DiscountAmount',
            headerName: 'Discount amount (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true
            // valueSetter: (val, row) => {
            //     const totalAmount = row?.Rate * row?.RequestedQuantity
            //     const discountAmount = totalAmount / 100 * row?.DiscountPercentage
            //     return {
            //         ...row,
            //         DiscountAmount: discountAmount
            //     }
            // },
            // valueGetter: (val, row) => {
            //     const totalAmount = row?.Rate * row?.RequestedQuantity
            //     const discountAmount = totalAmount / 100 * row?.DiscountPercentage
            //     return discountAmount
            // },
        }, {
            type: 'number',
            field: 'TaxableAmount',
            headerName: 'Taxable amount (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                var _row$SavedPriceWithTa5, _row$SavedPriceWithTa6;
                return (_row$SavedPriceWithTa5 = row === null || row === void 0 || (_row$SavedPriceWithTa6 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa6 === void 0 ? void 0 : _row$SavedPriceWithTa6.TaxableAmount) !== null && _row$SavedPriceWithTa5 !== void 0 ? _row$SavedPriceWithTa5 : 0;
            }
        }, {
            field: 'TaxComponentPercentageCGST',
            headerName: 'CGST (%)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                return getTaxComponentPercentage(row, 'CGST');
            }
        }, {
            type: 'number',
            field: 'CGSTAmount',
            headerName: 'CGST (₹)',
            width: 200,
            headerAlign: 'left',
            valueGetter: function (val, row) {
                return getTaxComponentAmount(row, 'CGST');
            }
        }, {
            field: 'SGSTPercentage',
            headerName: 'SGST (%)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                return getTaxComponentPercentage(row, 'SGST');
            }
        }, {
            type: 'number',
            field: 'SGSTAmount',
            headerName: 'SGST (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                return getTaxComponentAmount(row, 'SGST');
            }
        }, {
            field: 'IGSTPercentage',
            headerName: 'IGST (%)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                return getTaxComponentPercentage(row, 'IGST');
            }
        }, {
            type: 'number',
            field: 'IGSTAmount',
            headerName: 'IGST (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                return getTaxComponentAmount(row, 'IGST');
            }
        }, {
            type: 'number',
            field: 'Amount',
            headerName: 'Amount (₹)',
            width: 200,
            headerAlign: 'left',
            disableColumnMenu: true,
            valueGetter: function (val, row) {
                var _row$SavedPriceWithTa7, _row$SavedPriceWithTa8;
                return (_row$SavedPriceWithTa7 = row === null || row === void 0 || (_row$SavedPriceWithTa8 = row.SavedPriceWithTax) === null || _row$SavedPriceWithTa8 === void 0 ? void 0 : _row$SavedPriceWithTa8.Amount) !== null && _row$SavedPriceWithTa7 !== void 0 ? _row$SavedPriceWithTa7 : 0;
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Part",
        isCollapsible: true,
        columns: partsColumns
        // getToolbarActions={() => []}
        ,
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true,
            initialState: {
                pinnedColumns: {
                    left: ['__check__', 'PartName']
                },
                aggregation: {
                    model: {
                        Amount: 'sum',
                        IGSTAmount: 'sum',
                        SGSTAmount: 'sum',
                        CGSTAmount: 'sum',
                        TaxableAmount: 'sum',
                        Quantity: 'sum'
                    }
                }
            }
        },
        rows: currValue || [],
        onChange: onChange,
        error: error === null || error === void 0 ? void 0 : error[name]
    }));
};
